"use client";

import { useRouter } from "next/navigation";
import { useState, useTransition } from "react";
import { toggleFollow } from "@/lib/actions/social";

export function FollowButton({
  authorId,
  initialFollowing,
  signedIn,
  variant = "default",
}: {
  authorId: string;
  initialFollowing: boolean;
  signedIn: boolean;
  /** "banner" renders copper-on-green for the dark author banner. */
  variant?: "default" | "banner";
}) {
  const router = useRouter();
  const [following, setFollowing] = useState(initialFollowing);
  const [pending, startTransition] = useTransition();

  function onClick() {
    if (!signedIn) {
      router.push("/signin?next=" + encodeURIComponent(window.location.pathname));
      return;
    }
    // optimistic
    setFollowing((f) => !f);
    startTransition(async () => {
      const res = await toggleFollow(authorId);
      if ("error" in res) {
        setFollowing(initialFollowing);
        router.push("/signin");
      } else {
        setFollowing(res.following);
      }
    });
  }

  return (
    <button
      onClick={onClick}
      disabled={pending}
      className="h-[44px] rounded-[22px] px-6 text-[14px] font-bold transition-colors disabled:opacity-60"
      style={
        variant === "banner"
          ? following
            ? { background: "transparent", color: "#FCFAF5", border: "1px solid rgba(252,250,245,.45)" }
            : { background: "var(--copper)", color: "#FCFAF5" }
          : following
            ? { background: "var(--surface-alt2)", color: "var(--ink-2)" }
            : { background: "var(--green)", color: "var(--surface)", boxShadow: "var(--shadow-cta)" }
      }
    >
      {following ? "Following" : "Follow"}
    </button>
  );
}
